import qs from 'qs';
import buildUrl from 'build-url';

import facetsJson from './facets.json';
import refinementMap from './refinement-map.json';
import SLICategories from './categories.json';
import SLIHyphenMap from '../../../utils/SLIHyphenMap.json';
import slugToSLI from '../../../utils/slugToSLI';

// is this it? do we need to include more?
export const TRENDS_MAP = {
  'just-in': 'Just In',
  'on-sale': 'On Sale',
  exclusives: 'Exclusives',
  'all-time-best-sellers': 'All Time Best Sellers',
  monogrammable: 'Monogrammable',
  'best-sellers-this-season': 'Best Sellers This Season',
  'selling-fast': 'Selling Fast',
  'new-this-week': 'New This Week',
  'selling-fast-this-week': 'Selling Fast This Week',
  'selling-fast-today': 'Selling Fast Today',
  'most-wished': 'Most Wished',
  'new-today': 'New Today'
};

export const TRENDS_MAP_FROM_URL = {
  justin: 'Just In',
  onsale: 'On Sale',
  exclusives: 'Exclusives',
  alltimebestsellers: 'All Time Best Sellers',
  monogrammable: 'Monogrammable',
  bestsellersthisseason: 'Best Sellers This Season',
  sellingfast: 'Selling Fast',
  newthisweek: 'New This Week',
  sellingfastthisweek: 'Selling Fast This Week',
  sellingfasttoday: 'Selling Fast Today',
  mostwished: 'Most Wished',
  newtoday: 'New Today'
};

export const SORT_ITEMS = [
  { value: process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_INDEX, id: 'best_match', label: 'Best Match' },
  { value: `${process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_INDEX}_best_sellers`, id: 'best_sellers', label: 'Best Sellers' },
  { value: `${process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_INDEX}_just_in`, id: 'just_in', label: 'Just In' },
  { value: `${process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_INDEX}_price_asc`, id: 'price_asc', label: 'Price: Low to High' },
  { value: `${process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_INDEX}_price_desc`, id: 'price_desc', label: 'Price: High to Low' }
];

export const getFilters = (refinements) => refinements && Object.entries(refinements)
  .reduce((acc, curr) => {
    if (!Array.isArray(curr[1])) return acc;

    let af = acc;
    const key = refinementMap[curr[0]]?.id;

    if (!key) return af;
    if (key === 'trends') return af;

    const facets = curr[1].map((x) => {
      const facet = slugToSLI(x.toLowerCase());
      return `${key}:${facet}`;
    }).join('+');

    af = af ? `${af}+${facets}` : af += facets;
    return af;
  }, '');

export const getSortByMethod = (sortBy) => {
  if (!sortBy) return undefined;

  return sortBy === process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_INDEX
    ? 'best_match'
    : sortBy?.replace(`${process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_INDEX}_`, '');
};

export const getCategories = (cats) => {
  if (!cats) return null;
  const category = cats['categories.lvl0'];
  const categories = category.split(' > ').map((x) => {
    const slug = slugToSLI(x.toLowerCase());
    return SLIHyphenMap[slug] ?? slug;
  });
  return categories.join('/');
};

export const getPrice = (price) => {
  if (!price.min && !price.max) return null;
  return { min: price.min ?? '', max: price.max ?? '' };
};

// SLI --> ALGOLIA
export const pathToSearchState = (path) => {
  let hierarchicalMenu;
  let price;
  let refinementList;
  let sortBy;
  let toggle;
  let queryObject;

  const match = path.match(/\/(shop|brands|trends|lpc|edits)\//);

  if (match) {
    // get categories - yuck.
    hierarchicalMenu = match[1] === 'shop'
      ? path.split('?')[0].split(match[0])[1]?.split('/')
      // drop slug after (brands|trends|lpc|edits)
      : path.split('?')[0].split(match[0])[1]?.split('/')?.slice(1);

    if (hierarchicalMenu) {
      hierarchicalMenu = hierarchicalMenu
        .reduce((acc, curr, idx) => {
          const temp = acc;

          if (idx === 0) temp.push(slugToSLI(curr));
          if (idx === 1) temp.push(`${temp[0]}_${slugToSLI(curr)}`);
          if (idx === 2) temp.push(`${temp[1]}_${slugToSLI(curr)}`);

          return temp;
        }, [])
        .map((x, idx) => {
          const cat = SLICategories[idx].values.find((v) => v.id === x);
          return cat.name;
        });

      hierarchicalMenu = { 'categories.lvl0': hierarchicalMenu.join(' > ') };
    }

    // get brand
    if (match[1] === 'brands') {
      const value = path.split('?')[0].split(match[0])[1].split('/')[0];
      const brand = Object.values(facetsJson)
        .find((r) => r.id === 'brand')?.values
        .find((r) => r.id === slugToSLI(value))?.name;
      refinementList = { ...refinementList, brand: [brand] };
    }

    // get edit
    if (match[1] === 'edits') {
      const value = path.split('?')[0].split(match[0])[1].split('/')[0];
      refinementList = { ...refinementList, edits: [value] };
    }

    // get trend
    if (match[1] === 'trends') {
      const trend = path.split('?')[0].split(match[0])[1].split('/')[0];
      refinementList = refinementList?.trends
        ? { ...refinementList, trends: [TRENDS_MAP[trend]] }
        : { ...refinementList, trends: [TRENDS_MAP[trend]] };
    }
  }

  if (path.includes('?')) {
    queryObject = qs.parse(path.substring(path.indexOf('?') + 1));

    const { isort, af } = queryObject;

    if (af) {
      // split by space or +
      refinementList = [...new Set([...af.split(/[ +]+/)])];

      refinementList = refinementList.reduce((acc, curr) => {
        const temp = acc;
        const [k, f] = curr.split(':');

        if (k === 'sprice') {
          const [min, max] = f.replace(/\[|\]/g, '').split(',');
          price = { min: +min, max: max ? +max : null };
        } else if (k === 'trends') {
          temp.trends = temp.trends
            ? [...temp.trends, TRENDS_MAP_FROM_URL[f]]
            : [TRENDS_MAP_FROM_URL[f]];
        } else {
          const facet = Object.values(facetsJson)
            .find((r) => r.id === k)?.values
            .find((r) => r.id === f)?.name;

          if (facet) {
            const key = Object.keys(refinementMap).find((r) => refinementMap[r].id === k);
            if (!temp[key]) temp[key] = [];
            temp[key].push(facet);
          }
        }

        return temp;
      }, {});
    }

    if (isort) {
      const sortObj = SORT_ITEMS.find((x) => x.id === isort);
      if (sortObj) sortBy = sortObj.value;
    }
  }

  const state = {
    ...(queryObject && queryObject.w && { query: queryObject.w }),
    ...(toggle && { toggle }),
    ...(refinementList && { refinementList }),
    ...(hierarchicalMenu && { hierarchicalMenu }),
    ...(sortBy && { sortBy }),
    ...(price && {
      range: {
        'variants.maisonette_sale': {
          ...(price.min && { min: price.min }),
          ...(price.max && { max: price.max })
        }
      }
    })
  };

  return state;
};

export const createURL = (state, props) => {
  const {
    hierarchicalMenu,
    refinementList = {},
    sortBy,
    range,
    query
  } = state;

  let filters = getFilters(refinementList);
  const categories = getCategories(hierarchicalMenu);
  const sort = getSortByMethod(sortBy);
  const price = range && getPrice(range['variants.maisonette_sale']);

  if (price) {
    const sprice = `sprice:[${price.min},${price.max}]`;
    if (filters) filters += `+${sprice}`;
    else filters = sprice;
  }

  let url = '/shop';
  if (props.brand) url = `/${props.brand.permalink}`;
  if (props.trend) url = `/trends/${props.trend}`;
  if (props.lpc) url = `/lpc/${props.lpc}`;
  if (props.edit) url = `/edits/${props.edit}`;

  return buildUrl(
    url,
    {
      path: categories || undefined,
      ...(query || filters || sort) && {
        queryParams: {
          ...(query && { w: query }),
          ...(sort && { isort: sort }),
          ...(filters && { af: filters })
        }
      }
    }
  );
};
